<template>
  <div class="rkld">
    <div class="rkldRight">
      <div class="rkldRightContent">
        <!-- tabs导航 -->
        <el-tabs v-model="editableTabsValue" type="card">
          <el-tab-pane label="用户管理" name="1">
            <!--搜索框-->
            <div class="searchTj">
              <div class="searchTjHead">
                <span>查询条件</span>
                <i
                  class="searchDomw"
                  @click="showSearch = !showSearch"
                  :class="
                    showSearch == true
                      ? 'el-icon-arrow-up'
                      : 'el-icon-arrow-down'
                  "
                ></i>
              </div>
              <el-form
                :model="form"
                class="searchTjContent"
                v-show="showSearch"
              >
                <div class="searchTjContentDiv">
                  <span class="searchTjContentDivSpan" style="margin-right: 0"
                    >姓名</span
                  >
                  <el-input
                    v-model="form.customerName"
                    placeholder="请输入"
                    class="searchTjContentDivInput"
                  ></el-input>
                </div>
                <div class="searchTjContentDiv">
                  <span class="searchTjContentDivSpan">身份证号</span>
                  <el-input
                    v-model="form.customerIdcard"
                    placeholder="请输入"
                    class="searchTjContentDivInput"
                  ></el-input>
                </div>
                <div class="searchTjContentDiv">
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    class="searchBtns"
                    @click="query"
                    >查询
                  </el-button>
                </div>
                <div class="searchTjContentDiv">
                  <el-button type="info" icon="el-icon-delete" @click="resert"
                    >清除条件
                  </el-button>
                </div>
                <!-- <div
                  class='arrowDown'
                  @click='showSearch'
                  style='color: #000'
                >
                  <i class='el-icon-arrow-down'></i>
                </div> -->
              </el-form>
            </div>
            <div class="searchButtonDiv" v-show="quanbu">
              <div class="searchButtonDivLeft">
                 <div style="display: none">
                    <input @change="fileChange" id="speechUpload" type="file" />
                </div>
                <label for="speechUpload" class="labelImportBtn inDwonBtns">
         
          <span> <i class="el-icon-upload2"></i>导入数据</span>
        </label>
                <el-button
                  type="primary"
                   icon="el-icon-sold-out" class="button modelDownds shuiBtn"
                  size="medium"
                  @click="downExcel"
                  >下载模板</el-button
                >
              </div>
              <!-- 筛选按钮 -->
              <div class="searchButtonDiveRight">
                <el-button-group>
                  <el-button
                    type="primary"
                    icon="el-icon-refresh"
                    @click="resertTable"
                    class="dropRests"
                  ></el-button>
                  <!-- <el-button type="primary"> -->
                  <el-dropdown
                    class="dropdown"
                    trigger="click"
                    :hide-on-click="false"
                  >
                    <span class="el-dropdown-link">
                      <i
                        class="el-icon-s-grid el-icon--right"
                        style="color: #fff"
                      ></i>
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <template>
                          <el-checkbox-group
                            v-model="checkList"
                            :min="1"
                            @change="tableShow"
                          >
                            <el-checkbox label="序号">序号 </el-checkbox>
                            <br />
                            <el-checkbox label="姓名">姓名 </el-checkbox>
                            <br />
                            <el-checkbox label="是否补助人员"
                              >是否补助人员
                            </el-checkbox>
                            <br />
                            <el-checkbox label="补贴方式"
                              >补贴方式
                            </el-checkbox>
                            <br />
                            <el-checkbox label="餐补等级"
                              >餐补等级
                            </el-checkbox>
                            <br />
                            <el-checkbox label="余额">余额 </el-checkbox>
                            <br />
                            <el-checkbox label="操作">操作 </el-checkbox>
                            <br />
                          </el-checkbox-group>
                        </template>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- </el-button> -->
                </el-button-group>
              </div>
            </div>
            <!--表单-->
            <div class="addForm">
              <el-table
                ref="multipleTable"
                :data="tableDate"
                tooltip-effect="dark"
                @row-click="openDetails"
                highlight-current-row
                
                @selection-change="handleSelectionChange2"
                :header-cell-style="{
                  background: '#e6e6e6',
                  color: '#000',
                }"
                border
              >
                <el-table-column
                  type="selection"
                  width="50"
                  align="center"
                  @selection-change="handleSelectionChange"
                >
                </el-table-column>
                <el-table-column
                  type="index"
                  width="70"
                  label="序号"
                  align="center"
                  v-if="no1"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="customerName"
                  label="姓名"
                  align="center"
                  v-if="no2"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="phone"
                  label="电话"
                  align="center"
                  show-overflow-tooltip
                  v-if="no3"
                >
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="住址"
                  align="center"
                  width="200"
                  show-overflow-tooltip
                  v-if="no4"
                >
                </el-table-column>
                <el-table-column
                  prop="customerType"
                  label="年龄段"
                  align="center"
                  show-overflow-tooltip
                  v-if="no5"
                >
                </el-table-column>
                <el-table-column
                  prop="oldNumber"
                  label="数量"
                  align="center"
                  width="120"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                <el-table-column
                  prop="mealType"
                  label="饮食解决方式 "
                  align="center"
                   width="140"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                <el-table-column
                  prop="isDisturb"
                  label="是否为吃什么或独自一人不愿意做饭等问题烦恼"
                  align="center"
                  width="240"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                <el-table-column
                  prop="flavor"
                  label="饮食口味 "
                  align="center"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                <el-table-column
                  prop="isWillingCanteen"
                  label="是否愿意去老年食堂用餐 "
                  align="center"
                  width="200"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                 <el-table-column
                  prop="worry"
                  label="不去食堂顾虑 "
                  align="center"
                  width="170"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                 <el-table-column
                  prop="isDelivery"
                  label="是否有送餐服务需求 "
                  align="center"
                   width="170"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                <el-table-column
                  prop="isWillingPay"
                  label="送餐上门服务另收费能否接受 "
                  align="center"
                   width="170"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                <el-table-column
                  prop="withinThreekm"
                  label="距食堂半径范围3公里内（3元)"
                  align="center"
                   width="170"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                <el-table-column
                  prop="outThreekm"
                  label="超出食堂半径范围3公里内（5元)"
                  align="center"
                   width="170"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                <el-table-column
                  prop="mealNeeds"
                  label="就餐需求"
                  align="center"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                <el-table-column
                  prop="opinion"
                  label="意见和建议"
                  align="center"
                  show-overflow-tooltip
                  v-if="no6"
                >
                </el-table-column>
                <!-- <el-table-column
                  prop="operation"
                  label="操作"
                  align="center"
                  width="250px"
                  v-if="no7"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="查看"
                      placement="top-start"
                    >
                      <button
                        style="color: #000"
                        class="iconfont icon-chakan tabBtn"
                        @click="handleClick('查看', scope.row)"
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="编辑"
                      placement="top-start"
                    >
                      <button
                        style="color: #000"
                        class="iconfont icon-bianji3 tabBtn"
                        @click="handleClick('编辑', scope.row)"
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="充值"
                        placement="top-start"
                    >
                        <button
                            style="color: #000"
                            class="iconfont icon-bianji3 tabBtn"
                            @click="
                                handleClick(
                                    '充值',
                                    scope.row
                                )
                            "
                        ></button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="消费记录"
                      placement="top-start"
                    >
                      <button
                        style="color: #000"
                        class="iconfont icon-chakan tabBtn"
                        @click="showDialog('消费记录', scope.row)"
                      ></button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="删除"
                      placement="top-start"
                    >
                      <button
                        style="color: #000"
                        class="iconfont icon-icon7 tabBtn"
                        @click="deleteId(scope.row)"
                      ></button>
                    </el-tooltip>
                  </template>
                </el-table-column> -->
              </el-table>
              <!-- 分页 -->
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 新增功能模态框 -->
    <div class="addFrom">
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="990px"
        :before-close="handleClose"
        @close="dialogVisibleClone"
      >
        <div class="addDialogTabs">
          <div
            v-for="(item, index) in dialogTabs"
            :key="index"
            :class="{ borderBot: borderBotKey == index }"
            @click="selectDialogTabs(index)"
          >
            {{ item }}
          </div>
        </div>
        <el-form
          ref="addForm1"
          :model="addForm"
          :rules="addFormRules1"
          label-width="110px"
        >
          <div v-show="dialogBox == 0">
            <div class="dialogBody">
              <el-row :gutter="24">
                <el-col :span="9">
                  <el-form-item label="姓名：" prop="customerName">
                    <!-- <el-input
                      v-model='addForm.customerName'
                      :disabled="dialogTitle == '查看'"
                    ></el-input> -->
                    <el-autocomplete
                      class="inline-input"
                      style="width: 100%"
                      v-model="addForm.customerName"
                      :fetch-suggestions="querySearchAsync"
                      placeholder="请输入姓名"
                      :trigger-on-focus="false"
                      @select="handleSelect"
                      @input="clearForm"
                      :disabled="dialogTitle == '查看'"
                    >
                      <template v-slot="{ item }">
                        <span>{{ item.customerName }}</span>
                      </template>
                    </el-autocomplete>
                  </el-form-item>
                  <el-form-item
                    label="性别："
                    prop="customerSex"
                    style="margin-top: 20px"
                  >
                    <el-select
                      v-model="addForm.customerSex"
                      placeholder=""
                      style="width: 100%"
                      disabled
                    >
                      <el-option
                        v-for="item in sexOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="dialogTitle == '查看'"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="民族："
                    prop="nation"
                    style="margin-top: 20px"
                  >
                    <el-select
                      :disabled="dialogTitle == '查看'"
                      v-model="addForm.nation"
                      placeholder=""
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in nation"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="手机号："
                    prop="customerPhone"
                    style="margin-top: 20px"
                  >
                    <el-input
                      v-model="addForm.customerPhone"
                      :disabled="dialogTitle == '查看'"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="人员编号："
                    style="margin-top: 20px"
                    prop="faceIdcode"
                  >
                    <el-input
                      v-model="addForm.faceIdcode"
                      :disabled="dialogTitle == '查看'"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="身份证号：" prop="customerIdcard">
                    <el-input
                      v-model="addForm.customerIdcard"
                      :disabled="dialogTitle == '查看'"
                      @change="idCardchange"
                    ></el-input>
                    <!-- @change="serchSubsidy;idCardchange" -->
                  </el-form-item>
                  <el-form-item
                    label="出生年月："
                    prop="customerBirthday"
                    style="margin-top: 20px"
                  >
                    <!-- :disabled="dialogTitle == '查看'" -->
                    <el-date-picker
                      disabled
                      v-model="addForm.customerBirthday"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item
                    label="年龄："
                    prop="customerAge"
                    style="margin-top: 20px"
                  >
                    <el-input v-model="addForm.customerAge" disabled></el-input>
                  </el-form-item>
                  <el-form-item
                    label="政治面貌："
                    prop="customerPolitical"
                    style="margin-top: 20px"
                  >
                    <el-select
                      v-model="addForm.customerPolitical"
                      placeholder="政治面貌"
                      :disabled="dialogTitle == '查看'"
                    >
                      <el-option label="中共党员" value="0"></el-option>
                      <el-option label="共青团员" value="1"></el-option>
                      <el-option label="群众" value="2"></el-option>
                      <el-option label="其他" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="就餐卡编号:" style="margin-top: 20px">
                    <el-input
                      v-model="addForm.intoCard"
                      @change="intoCardChange(addForm.intoCard)"
                    ></el-input>
                  </el-form-item>
                  <!-- <el-form-item
                                   label="组织机构："
                                   style="height:40px;margin-top: 20px;"
                                   prop="orgName"
                                 > -->
                  <!--                  <el-select-->
                  <!--                    style="width: 100%;"-->
                  <!--                    class="marginT34"-->
                  <!--                    v-model="addForm.orgName"-->
                  <!--                    placeholder="请选择组织机构"-->
                  <!--                    ref="selectBoxRef"-->
                  <!--                    :disabled="dialogTitle == '查看'"-->
                  <!--                  >-->
                  <!--                    <el-option :value="addForm.orgName" style="height: auto;">-->
                  <!--                      <el-tree-->
                  <!--                        :data="orgList"-->
                  <!--                        :props="defaultProps"-->
                  <!--                        ref="tree"-->
                  <!--                        @node-click="handleEditNodeClick"-->
                  <!--                        class="tree_box"-->
                  <!--                      ></el-tree>-->
                  <!--                    </el-option>-->
                  <!--                  </el-select>-->
                  <!-- </el-form-item> -->
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="customerPhoto" label-width="0px">
                    <el-upload
                      :disabled="dialogTitle == '查看'"
                      :show-file-list="false"
                      :before-upload="beforeAvatarUpload"
                      :action="actionUrl"
                      list-type="picture-card"
                      :limit="1"
                      :on-success="handleAvatarSuccess"
                      :on-preview="handlePicturePreview"
                      :on-exceed="handleExceed"
                    >
                      <img
                        v-if="addForm.customerPhoto"
                        :src="addForm.customerPhoto"
                        class="avatar"
                      />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-form-item
              label="居住情况："
              prop="customerJzqk"
              style="display: contents"
            >
              <el-radio
                v-model="addForm.customerJzqk"
                label="4"
                :disabled="dialogTitle == '查看'"
                >独自居住
              </el-radio>
              <el-radio
                v-model="addForm.customerJzqk"
                label="5"
                :disabled="dialogTitle == '查看'"
                >与配偶居住
              </el-radio>
              <el-radio
                v-model="addForm.customerJzqk"
                label="3"
                :disabled="dialogTitle == '查看'"
                >与子女居住
              </el-radio>
              <el-radio
                v-model="addForm.customerJzqk"
                label="6"
                :disabled="dialogTitle == '查看'"
                >其他
              </el-radio>
            </el-form-item>
            <el-form-item label="经济来源：" prop="economySource">
              <el-checkbox-group
                v-model="addForm.economySource"
                :disabled="dialogTitle == '查看'"
              >
                <el-checkbox label="0">养老金</el-checkbox>
                <el-checkbox label="1">子女供养</el-checkbox>
                <el-checkbox label="2">救济优抚</el-checkbox>
                <el-checkbox label="3">兼职</el-checkbox>
                <el-checkbox label="4">其他</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <div class="dialogBody" style="margin-top: 10px">
              <el-form-item label="居住地址：">
                <el-button
                  type="danger"
                  icon="el-icon-location-outline"
                  @click="location"
                  >定位到标准地址
                </el-button>
              </el-form-item>
            </div>
            <!-- <el-col :span="24" v-show="mapshow"> -->
            <el-form-item label="" v-show="mapshow">
              <el-row>
                <el-col :span="4">
                  <el-form-item>
                    <el-select
                      v-model="addForm.provinceId"
                      placeholder="请选择省"
                      @change="handleProvince"
                      :disabled="
                        normalInfo.orgLevel == 1 ||
                        normalInfo.orgLevel == 2 ||
                        normalInfo.orgLevel == 3 ||
                        normalInfo.orgLevel == 4 ||
                        normalInfo.orgLevel == 5 ||
                        dialogTitle == '查看'
                      "
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item, index) in provinceList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="addForm.cityid"
                    placeholder="请选择市"
                    @change="handleCity"
                    :disabled="
                      normalInfo.orgLevel == 2 ||
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      dialogTitle == '查看'
                    "
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in cityList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="addForm.zoneid"
                    placeholder="请选择区"
                    @change="handleArea"
                    :disabled="
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      dialogTitle == '查看'
                    "
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in areaList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="addForm.streetid"
                    placeholder="请选择街道"
                    :disabled="
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      dialogTitle == '查看'
                    "
                    @change="streetChange"
                  >
                    <el-option
                      v-for="(item, index) in streetList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode + index"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="addForm.shequid"
                    :disabled="
                      normalInfo.orgLevel == 5 || dialogTitle == '查看'
                    "
                    placeholder="请选择社区"
                  >
                    <el-option
                      v-for="item in communityList"
                      :key="item.id"
                      :label="item.address"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-form-item prop="address">
                <input
                  v-model.trim="addForm.customerAddress"
                  :disabled="dialogTitle == '查看'"
                  id="tipinput"
                  class="el-input__inner"
                  :class="dialogTitle == '查看' ? 'innerCur' : ''"
                  @focus="getMap('tipinput')"
                  placeholder="请输入关键字"
                  autocomplete="off"
                />
              </el-form-item>
              <div class="map_container">
                <div
                  class="map_right"
                  id="container"
                  style="width: 100%; height: 300px"
                ></div>
              </div>
              <!-- <div id="myPageTop">
  <input id="tipinput" autocomplete="off" @focus="changeAddress"/>
  </div> -->
            </el-form-item>
          </div>
          <div v-show="dialogBox == 1">
            <el-form-item label="是否补助人员" prop="isSubsidy" width="100%">
              <el-radio-group v-model="addForm.isSubsidy" @change="btfsbh">
                <el-radio label="0" :disabled="dialogTitle == '查看'"
                  >是
                </el-radio>
                <el-radio label="1" :disabled="dialogTitle == '查看'"
                  >否
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="补贴开始时间"
              prop="subsidyStartTime"
              v-if="addForm.isSubsidy == 0"
            >
              <el-date-picker
                :disabled="dialogTitle == '查看'"
                v-model="addForm.subsidyStartTime"
                @change="timechange"
                type="date"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                size="small"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="补贴时长"
              prop="subsidyTime"
              style="margin-top: 15px"
              v-if="addForm.isSubsidy == 0"
            >
              <el-select
                :disabled="dialogTitle == '查看'"
                v-model="addForm.subsidyTime"
                placeholder="请选择"
                style="width: 100%"
                @change="timechange"
              >
                <el-option
                  v-for="item in scoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="补贴结束时间"
              prop="subsidyEndTime"
              style="margin-top: 15px"
              v-if="addForm.isSubsidy == 0"
            >
              <el-date-picker
                disabled
                v-model="addForm.subsidyEndTime"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                size="small "
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item
              label="补贴方式"
              prop="subsidyWay"
              style="margin-top: 15px"
              v-if="addForm.isSubsidy == 0"
            >
              <!-- <el-radio
                  v-model="addForm.subsidyWay"
                  label="0"
                  :disabled="dialogTitle == '查看'"
                  >按月</el-radio
              >
              <el-radio
                  v-model="addForm.subsidyWay"
                  label="1"
                  :disabled="dialogTitle == '查看'"
                  >按次</el-radio
              > -->
              <el-radio-group v-model="addForm.subsidyWay" @change="showlist1">
                <el-radio label="0" :disabled="dialogTitle == '查看'"
                  >按月
                </el-radio>
                <el-radio label="1" :disabled="dialogTitle == '查看'"
                  >按次
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="餐补等级"
              prop="subsidyLevel"
              style="margin-top: 15px"
              v-if="addForm.isSubsidy == 0"
            >
              <el-select
                :disabled="dialogTitle == '查看'"
                v-model="addForm.subsidyLevel"
                placeholder="餐补等级"
                size="small "
                style="width: 100%"
                @change="subMoney"
              >
                <el-option
                  v-for="item in subsidyLevelOptions"
                  :key="item.id"
                  :label="item.gradeName"
                  :value="String(item.id)"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="补贴金额"
              prop="subsidyMoney"
              style="margin-top: 15px"
              v-if="addForm.isSubsidy == 0"
            >
              <el-input
                disabled
                v-model="addForm.subsidyMoney"
                size="small"
                width="100%"
                placeholder="获取补贴金额"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="补贴次数"
              prop="enableNum"
              style="margin-top: 15px"
              v-if="addForm.isSubsidy == 0 && addForm.subsidyWay == 1"
            >
              <el-input
                disabled
                v-model="addForm.enableNum"
                size="small"
                width="100%"
                placeholder="获取补贴次数"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="补贴总额"
              prop="subsidyTotal"
              style="margin-top: 15px"
              v-if="addForm.isSubsidy == 0"
            >
              <el-input
                disabled
                v-model="addForm.subsidyTotal"
                size="small"
                width="100%"
                placeholder="获取补贴总额"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="补贴总次数"
              prop="enableallNum"
              style="margin-top: 15px"
              v-if="addForm.isSubsidy == 0 && addForm.subsidyWay == 1"
            >
              <el-input
                disabled
                v-model="addForm.enableallNum"
                size="small"
                width="100%"
                placeholder="获取补贴总次数"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="每次补贴金额"
              prop="enableAmount"
              style="margin-top: 15px"
              v-if="addForm.isSubsidy == 0 && addForm.subsidyWay == 1"
            >
              <el-input
                disabled
                v-model="addForm.enableAmount"
                size="small"
                width="100%"
                placeholder="获取每次补贴金额"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="余额"
              prop="subsidyBalance"
              style="margin-top: 15px"
            >
              <el-input
                disabled
                v-model="addForm.subsidyBalance"
                size="small"
                width="100%"
                placeholder="获取金额"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="充值金额"
              prop="intoMoney"
              style="margin-top: 15px"
              v-if="addForm.isSubsidy == 1"
            >
              <el-input
                :disabled="dialogTitle == '查看'"
                v-model="addForm.intoMoney"
                size="small"
                width="100%"
                placeholder="请输入"
                @input="czjggb"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="支付方式："
              prop="intoType"
              style="margin-top: 15px"
              v-if="addForm.isSubsidy == 1"
            >
              <el-radio-group
                v-model="addForm.intoType"
                :disabled="dialogTitle == '查看'"
              >
                <el-radio label="0">支付宝支付</el-radio>
                <el-radio label="1">微信支付</el-radio>
                <el-radio label="2">现金</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              v-if="addForm.isSubsidy == 1"
              style="margin-top: 15px"
            >
              <div class="payment_item" v-if="addForm.intoType == 0">
                <img
                  src="@/assets/paymentimg/zhifubao.png"
                  alt=""
                  style="width: 350px"
                />
                <!-- <h6>支付宝支付</h6> -->
              </div>
              <div class="payment_item" v-if="addForm.intoType == 1">
                <img
                  src="@/assets/paymentimg/weixin.jpg"
                  alt=""
                  style="width: 350px"
                />
                <!-- <h6>微信支付</h6> -->
              </div>
              <!-- <div class="payment_item" v-if="addForm.intoType == 2">
                  <img src="@/assets/paymentimg/r4.png" alt="" />
                  <h6>现金支付</h6>
              </div> -->
            </el-form-item>

            <el-form-item label="总金额" prop="totalMoney">
              <el-input
                disabled
                v-model="addForm.totalMoney"
                size="small"
                placeholder="获取金额"
                width="100%"
              ></el-input>
            </el-form-item>
          </div>
          <!-- </el-col> -->
        </el-form>
        <!-- <el-form
            ref="addForm2"
            :model="addForm"
            :rules="addFormRules2"
            label-width="120px"
        >
        </el-form> -->
        <div slot="footer" v-if="dialogTitle != '查看'">
          <el-button type="primary" @click="save">确定</el-button>
          <el-button @click="cancel('addForm')">取消</el-button>
        </div>
      </el-dialog>

      <!-- 消费记录 -->
      <el-dialog
        title="消费记录"
        :visible.sync="dialogVisible2"
        @close="dialogVisibleClone30"
        width="50%"
      >
        <table
          ref="print"
          border="1"
          cellspacing="0"
          cellpadding="0"
          style="border-collapse: collapse; text-align: center; width: 100%"
        >
          <tr style="height: 40px">
            <td width="10%">序号</td>
            <td width="30%">时间</td>
            <td width="40%">内容</td>
            <td wodth="10%">消费金额</td>
            <td width="10%">余额</td>
          </tr>
          <tr
            v-for="(item, index) in consumption"
            :key="index"
            style="height: 40px"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ item.createDate }}</td>
            <td>
              <span v-if="item.intoCostType == 0">
                <span v-if="item.orderType == 1">早餐</span>
                <span v-if="item.orderType == 2">午餐</span>
                <span v-if="item.orderType == 3">晚餐</span>
              </span>
              <span v-if="item.intoCostType == 1">
                <span>支入</span>
              </span>
            </td>
            <td>
              <span v-if="item.intoCostType == 0" style="color: red"
                >-{{ item.paymentAmount }}</span
              >
              <span v-if="item.intoCostType == 1" style="color: green"
                >+{{ item.paymentAmount }}</span
              >
            </td>
            <td>{{ item.sum }}</td>
          </tr>
        </table>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="stamp">打印</el-button>
          <el-button @click="dialogVisible2 = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import common from "../../../utils/common.js"
import request from "@/utils/request.js"
import request2 from "@/utils/request2.js"
import AMap from "AMap" // 引入高德地图
import { discriCard, chekCode, chekPhone } from "@/views/elderManage/util"
import baseURL from "@/api/baseURL"
import { Collapse } from "element-ui"

export default {
  data() {
    var checkIdCode = (rule, value, callback) => {
      if (!chekCode(value)) {
        return callback(new Error("身份证号格式错误"))
      }
      const info = discriCard(value)
      this.addForm.customerSex = info.sex
      callback()
    }
    // const validateSpace = (rule, value, callback) => {
    //     if (isSpace(value)) {
    //       return callback(new Error('请输入非空格字符！'))
    //     } else if (!value) {
    //       return callback(new Error('请输入必填项！'))
    //     } else {
    //       return callback()
    //     }
    //   }
    return {
      defaultProps: {
        children: "children",
        label: "label",
      },
      orgList: [],
      arrOrgList: [],
      dialogVisible11: false,
      // 图片地址
      actionUrl: baseURL + "/sqyl/controller/uploadController/info/uploadPhoto",
      // 图片上传
      dialogImageUrl: "",
      dialogVisible1: false,
      photo: [],
      // 表单验证
      addFormRules1: {
        // orgName: [
        //   {required: true, message: "请选择组织机构", trigger: "change"},
        // ],
        customerName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        economySource: [
          {
            // type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        customerIdcard: [
          {
            required: true,
            message: "请输入身份证号码",
            trigger: "blur",
          },
          {
            pattern:
              /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: "证件号码格式有误！",
            trigger: "blur",
          },
        ],
        subsidyStartTime: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        subsidyLevel: [{ required: true, message: "请选择", trigger: "blur" }],
        subsidyTime: [{ required: true, message: "请选择", trigger: "blur" }],
        subsidyWay: [{ required: true, message: "请选择", trigger: "blur" }],
      },
      selectedData: [],
      // 消费表单
      consumption: [],
      // 消费记录
      dialogVisible2: false,
      // 图片上传
      imgdialog: false,
      // 地图显示
      mapshow: false,
      showtext: true,
      // 新增功能模态框初始状态
      dialogVisible: false,
      // --------------------------------------------
      // 筛选数据功能按钮初始值
      checkList: [
        "序号",
        "姓名",
        "是否补助人员",
        "补贴方式",
        "餐补等级",
        "余额",
        "操作",
      ],
      // 新增模态框导航
      dialogTabs: ["基本信息", "充值信息"],
      borderBotKey: 0,
      dialogBox: 0,
      dialogTitle: "",
      // 新增模态框性别
      sexOptions: [
        {
          value: "0",
          label: "男",
        },
        {
          value: "1",
          label: "女",
        },
      ],
      scoptions: [
        {
          value: "1",
          label: "1个月",
        },
        {
          value: "2",
          label: "2个月",
        },
        {
          value: "3",
          label: "3个月",
        },
        {
          value: "4",
          label: "4个月",
        },
        {
          value: "5",
          label: "5个月",
        },
        {
          value: "6",
          label: "6个月",
        },
        {
          value: "7",
          label: "7个月",
        },
        {
          value: "8",
          label: "8个月",
        },
        {
          value: "9",
          label: "9个月",
        },
        {
          value: "10",
          label: "10个月",
        },
        {
          value: "11",
          label: "11个月",
        },
        {
          value: "12",
          label: "12个月",
        },
      ],
      options: [
        {
          value: "0",
          label: "县",
        },
        {
          value: "1",
          label: "市",
        },
        {
          value: "2",
          label: "省",
        },
      ],
      // 民族
      nation: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ],

      // 新增模态框餐补等级
      subsidyLevelOptions: [],
      // 新增模态框居住情况
      live: "",
      // from表单
      tableDate: [],
      // czje:'',
      // zffs:'',
      // 新增模态框
      addForm: {
        // czje:'',
        // zffs:'',
        faceIdcode: "",
        customerPolitical: "",
        photo: "",
        customerName: "",
        customerIdcard: "",
        customerBirthday: "",
        customerAge: "",
        customerSex: "",
        customerPhone: "",
        customerAddress: "",
        // address1: "",
        // address2: "",
        // address3: "",
        provinceId: "", //省
        cityid: "", //市
        zoneid: "", //区
        streetid: "", //街道
        shequid: "", //社区
        addressLng: "", //经度
        addressLat: "", //纬度
        address: "", //详细地址
        customerJzqk: "",
        // economySource: "",
        economySource: [],
        serviceStation: "",
        isSubsidy: "0",
        subsidyStartTime: "",
        totalMoney: "",
        subsidyEndTime: "",
        subsidyWay: "",
        subsidyLevel: "",
        subsidyMoney: "",
        subsidyTotal: "",
        subsidyBalance: "0",
        subsidyBalance1: "",
        customerPhoto: "",
      },
      // 图片地址
      imageUrl: "",
      // --------------------------------------------
      // 筛选按钮功能控制表头是否显示初始状态
      no1: true,
      no2: true,
      no3: true,
      no4: true,
      no5: true,
      no6: true,
      no7: true,
      // --------------------------------------------
      showSearch: true,
      // dyxx: false,
      // 功能按钮显示初始状态
      quanbu: true,
      currentPage: 1, //默认展示第一页
      total: 0, //总数据
      timer: "", //定义一个定时器的变量
      currentTime: new Date(), // 获取当前时间
      currentTime1: new Date(), // 获取当前时间
      searchValue: true,
      showSlide: true,
      editableTabsValue: "1",
      tabIndex: 1,
      input: "",
      value: "",
      valueSq: "",
      multipleSelection: [],
      currentPage4: 4,
      pageNo: 1,
      pageSize: 10,
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1,
      },
      form: {
        personName: "",
        idCode: "",
        linkPhone: "",
        gridCode: "",
        pageNo: 1,
        pageSize: 10,
      },
      visVisible: false,
      userform: {},
      formSwitch: 2,
      familyform: {},
      arorreset: "add",
      // 所有图片名集合
      imgTitleList: ["photo"],
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      myMap: null,
      marker: null, //地图标记点
      polygons: [],
      isMap: true,
      normalInfo: {},
    }
  },
  inject: ["reload"], //注入
  created() {
    // this.getOrg()
    // this.getProvince()
    this.showlist()
    // this.getchangeList()

    // this.showlist1()
  },
  methods: {
    // 下载模板
    async downExcel() {
      const res = await request2({
        url: "/sqyl/survery/info/downloadExcel",
        method: "POST",
        data: {
          postName: "*",
        },
        responseType: "blob",
      })
      const blob = new Blob([res], { type: "application/vnd.ms-excel" })
      const fileName = "老年人数据.xls"
      const linkNode = document.createElement("a")

      linkNode.download = fileName //a标签的download属性规定下载文件的名称
      linkNode.style.display = "none"
      linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
      document.body.appendChild(linkNode)
      linkNode.click() //模拟在按钮上的一次鼠标单击

      URL.revokeObjectURL(linkNode.href) // 释放URL 对象
      document.body.removeChild(linkNode)
    },
    //导入数据
    async fileChange(event) {
      console.log(event)
      const file = event.target.files[0]
      console.log(file)
      const personType = "2"
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      }
      let formData = new FormData()
      formData.append("personType", personType)
      console.log(formData)
      formData.append("file", file)
      let result = await this.$http.post(
        "/sqyl/survery/info/excel",
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById("speechUpload")
      fileEle.value = ""
      if (result.code == 200) {
        this.$message.success(result.message)
        this.getTableData()
      } else {
        this.$message.warning(result.message)
      }
    },
    intoCardChange(val) {
      // if(this.dialogTitle != '新增'){
      //   this
      // }
      this.$http
        .request({
          url: "/sqyl/admin/customer/info/checkUnique",
          method: "POST",
          data: {
            intoCard: val,
            id: this.addForm.id,
          },
        })
        .then((res) => {
          if (res.code == 200) {
          }
        })
    },
    getchangeList() {
      this.$http
        .request({
          url: "/ypt/admin/all/customer/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 99,
            // customerName:queryString
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content != null) {
              this.list = res.content.list
            }
          }
        })
    },
    querySearchAsync(queryString, cb) {
      let result = this.list.filter((item) => {
        if (item.customerName.indexOf(queryString) > -1) {
          return true
        }
      })
      cb(result)
    },
    async handleSelect(item) {
      console.log(item)
      this.$set(this.addForm, "customerName", item.customerName)
      this.$set(this.addForm, "customerSex", item.gender)
      this.$set(this.addForm, "nation", item.nation)
      this.$set(this.addForm, "customerPhone", item.phone)
      this.$set(this.addForm, "customerIdcard", item.idCard)
      this.$set(this.addForm, "customerBirthday", item.birthday)
      this.$set(this.addForm, "customerAge", item.age)
      this.$set(this.addForm, "customerJzqk", item.liveCondition)
      this.$set(this.addForm, "economySource", item.economicSource)
      this.$set(this.addForm, "economySource", item.economicSource)
      this.addForm.economySource = this.addForm.economySource.split(",")
      this.$set(this.addForm, "provinceId", item.provinceId)
      this.$set(this.addForm, "cityid", item.cityId)
      console.log(this.addForm.cityid, item.cityId)
      this.$set(this.addForm, "zoneid", item.areaId)
      this.$set(this.addForm, "streetid", item.streetId)
      this.$set(this.addForm, "shequid", item.communityId)
      this.$set(this.addForm, "customerAddress", item.address)
      this.$set(this.addForm, "longitude", item.longitude)
      this.$set(this.addForm, "latitude", item.latitude)
      this.addForm.provinceId = String(this.addForm.provinceId)
      if (!this.addForm.provinceId) return
      let city = await this.getDistricts(this.addForm.provinceId)
      this.cityList = city.districtList
      if (!this.addForm.cityid) return
      this.addForm.cityid = String(this.addForm.cityid)
      let area = await this.getDistricts(this.addForm.cityid)
      this.areaList = area.districtList
      if (!this.addForm.zoneid) return
      this.addForm.zoneid = String(this.addForm.zoneid)
      let street = await this.getDistricts(this.addForm.zoneid)
      self.streetList = street.districtList
      if (!this.addForm.streetid) return
      this.addForm.streetid = String(this.addForm.streetid)
      let communityList = await this.getCommityList(this.addForm.streetid)
      this.communityList = communityList
      this.addForm.shequid = Number(this.addForm.shequid) //社区
      console.log(this.addForm.longitude, this.addForm.latitude)
      this.loadmap("container")
      setTimeout(() => {
        this.potintMap()
      }, 500)
      this.$forceUpdate()
      let issure = ""
      this.issure = true
    },
    //监控姓名是否为空
    clearForm(val) {
      if (this.issure == true) {
        this.$refs["addForm"].resetFields()
        this.changeFirst()
      }
    },
    changeAddress() {
      this.getMap()
    },

    loopNode(node, arr) {
      if (node.parent == null) {
        return arr
      } else {
        arr.push(node.data.orgId)
        this.loopNode(node.parent, arr)
      }
    },
    handleEditNodeClick(data, node) {
      const clickNode = this.$refs.tree.getNode(node)
      const arr = []
      this.loopNode(clickNode, arr)
      this.arrOrgList = arr
      let obj = common.organization(this.arrOrgList, this.normalInfo.orgLevel)
      this.$set(this.addForm, "orgId", data.orgId)
      this.$set(this.addForm, "parentId", data.parentId)
      this.$set(this.addForm, "orgType", data.orgType)
      this.$set(this.addForm, "orgName", data.label)

      this.$set(this.addForm, "qujiId", obj.qujiId)
      this.$set(this.addForm, "shengjiId", obj.shengjiId)
      this.$set(this.addForm, "shijiId", obj.shijiId)
      this.$set(this.addForm, "stationId", obj.stationId)
      this.$set(this.addForm, "shequjiId", obj.shequjiId)
      this.$refs["selectBoxRef"].handleClose()
    },
    getOrg() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getMap(input) {
      const self = this
      const autoOptions = {
        city: this.addForm.zoneid,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.addForm.address = e.poi.name
        self.addForm.addressLng = e.poi.location.lng
        self.addForm.addressLat = e.poi.location.lat
        console.log(e.poi.location, "地址")
        self.potintMap()
      })
    },
    async changeFirst() {
      console.log(
        this.normalInfo,
        "机构信息 normalInfo.orgLevel",
        this.provinceList
      )
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistricts(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
        console.log("城市", this.cityList)
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getDistricts(this.normalInfo.cityId)
        this.areaList = areaList.districtList
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getDistricts(this.normalInfo.areaId)
        this.streetList = streetList.districtList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getCommityList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            this.addForm.addressLat = item.center.lat
            this.addForm.addressLng = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            this.addForm.addressLat = item.center.lat
            this.addForm.addressLng = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        this.areaList.forEach((item) => {
          if (item.adcode == this.normalInfo.areaId) {
            this.addForm.addressLat = item.center.lat
            this.addForm.addressLng = item.center.lng
          }
        })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.adcode + index == this.normalInfo.streetId) {
            this.addForm.addressLat = item.center.lat
            this.addForm.addressLng = item.center.lng
          }
        })
      }
      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }

      this.addForm.provinceId = this.normalInfo.provinceId
      this.addForm.cityid = this.normalInfo.cityId
      this.addForm.zoneid = this.normalInfo.areaId
      this.addForm.streetid = this.normalInfo.streetId
      this.addForm.shequid = this.normalInfo.communityId
      this.loadmap("container")
      setTimeout(() => {
        this.potintMap()
      }, 500)
      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 打点
    potintMap() {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(self.addForm.addressLng),
          Number(self.addForm.addressLat),
        ],
      })
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },
    //街道地址发生变化
    async streetChange(val) {
      let communityList = await this.getCommityList(val)
      this.communityList = communityList
      this.joinAddress()
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    dialogVisibleClone30() {
      this.consumption = []
    },
    // save1(){
    //   console.log(this.addForm)
    // },
    dialogVisibleClone() {
      this.addForm.provinceId = ""
      // this.addForm.subsidyTime = ''
      // this.addForm.subsidyEndTime = ''
      this.addForm.cityid = ""
      this.addForm.zoneid = ""
      this.addForm.streetid = ""
      this.addForm.shequid = ""
      this.addForm.customerAddress = ""
      delete this.addForm.id
      this.borderBotKey = 0
      this.dialogBox = 0
      this.addForm.intoCard = ""
      // this.addForm.customerPolitical= ""
      //   this.addForm.photo= ""
      //   this.addForm.customerName= ""
      //   this.addForm.customerIdcard= ""
      //   this.addForm.customerBirthday= ""
      //   this.addForm.customerAge= ""
      //   this.addForm.customerSex= ""
      //   this.addForm.customerPhone= ""
      //   // this.addForm.customerAddress= ""

      //   this.addForm.provinceId= "" //省
      //   this.addForm.cityid= "" //市
      //   this.addForm.zoneid= "" //区
      //   // streetid= "" //街道
      //   // shequid= "" //社区
      //   this.addForm.addressLng= "" //经度
      //   this.addForm.addressLat= "" //纬度
      //   // address= "" //详细地址
      //   this.addForm.customerJzqk= ""
      //   // economySource= ""
      //   this.addForm.economySource= []
      //   this.addForm.serviceStation= ""
      //   this.addForm.isSubsidy= ""
      //   this.addForm.subsidyStartTime= ""
      //   this.addForm.totalMoney=''
      //   this.addForm.subsidyEndTime= ""
      //   this.addForm.subsidyWay= ""
      //   this.addForm.subsidyLevel= ""
      //   this.addForm.subsidyMoney= ""
      //   this.addForm.subsidyTotal= ""
      //   this.addForm.subsidyBalance= "0"
      //   this.addForm.totalMoney= ""
      //   this.addForm.customerPhoto= ""
    },
    czjggb() {
      this.addForm.totalMoney =
        Number(this.addForm.intoMoney) + Number(this.addForm.subsidyBalance)
    },
    czjggb1(val) {
      // this.addForm.subsidyBalance1 = val;
      this.addForm.totalMoney =
        Number(this.addForm.intoMoney) + Number(this.addForm.subsidyBalance1)
    },
    btfsbh(val) {
      console.log(this.dialogTitle)
      console.log(val)
      if (this.dialogTitle == "新增") {
        this.addForm.totalMoney = ""
      }
      // 如果选择了否 清除补贴相关信息
      if (val == 1) {
        delete this.addForm.subsidyStartTime
        delete this.addForm.subsidyTime
        delete this.addForm.subsidyEndTime
        delete this.addForm.subsidyLevel
      }
    },

    timechange() {
      console.log(this.addForm.subsidyStartTime, this.addForm.subsidyTime)
      // let d = new Date(this.addForm.subsidyStartTime)
      this.addForm.subsidyWay = ""
      this.addForm.subsidyLevel = ""
      this.addForm.subsidyMoney = ""
      this.addForm.subsidyTotal = ""
      this.addForm.subsidyBalance1 = ""
      this.addForm.enableNum = ""
      this.addForm.totalMoney = ""
      this.addForm.enableAmount = ""
      this.addForm.enableallNum = ""
      this.addForm.totalMone = ""
      // d.setTime(d.getTime() + 3600 * 1000 * 24 * 7);
      // console.log(d)
      // console.log(this.addForm.subsidyEndTime)

      let str = this.addForm.subsidyStartTime.split("-")
      let d = new Date(str[0], str[1], str[2])
      // 因为getMonth()获取的月份的值只能在0~11之间所以我们在进行setMonth()之前先给其减一
      //  d.setMonth((d.getMonth()-1) + this.addForm.subsidyTime);
      //  let yy1 = d.getFullYear();
      //  let mm1 = d.getMonth()+1;
      //  let dd1 = d.getDate()-1;
      let yy = parseInt(str[0])
      let mm = parseInt(str[1])
      let dt = parseInt(str[2])
      let num = d.getMonth() + parseInt(this.addForm.subsidyTime)
      if (num / 12 > 1) {
        yy += Math.floor(num / 12)
        mm = num % 12
      } else {
        mm += parseInt(this.addForm.subsidyTime)
      }

      //  if(dd1 == '00'){
      //    mm1 = parseInt(mm1)-1;
      //    let new_date = new Date(yy1,mm1,1);
      //    dd1 = (new Date(new_date.getTime()-1000*60*60*24)).getDate()
      //  }
      //  if (mm1 < 10 ) {
      //    mm1 = '0' + mm1;
      //  }
      //  if (dd1 < 10) {
      //    dd1 = '0' + dd1;
      //  }
      if (dt < 10) {
        dt = "0" + dt
      }
      if (mm < 10) {
        mm = "0" + mm
      }
      this.addForm.subsidyEndTime = yy + "-" + mm + "-" + dt
      console.log(this.addForm.subsidyEndTime)
      return yy + "-" + mm + "-" + dt
    },

    // 筛选功能按钮
    tableShow() {
      if (this.checkList.length > 0) {
        if (this.checkList.findIndex((obj) => obj == "序号") == -1) {
          this.no1 = false
        } else {
          this.no1 = true
        }
        if (this.checkList.findIndex((obj) => obj == "姓名") == -1) {
          this.no2 = false
        } else {
          this.no2 = true
        }
        if (this.checkList.findIndex((obj) => obj == "是否补助人员") == -1) {
          this.no3 = false
        } else {
          this.no3 = true
        }
        if (this.checkList.findIndex((obj) => obj == "补贴方式") == -1) {
          this.no4 = false
        } else {
          this.no4 = true
        }
        if (this.checkList.findIndex((obj) => obj == "餐补等级") == -1) {
          this.no5 = false
        } else {
          this.no5 = true
        }
        if (this.checkList.findIndex((obj) => obj == "余额") == -1) {
          this.no6 = false
        } else {
          this.no6 = true
        }
        if (this.checkList.findIndex((obj) => obj == "操作") == -1) {
          this.no7 = false
        } else {
          this.no7 = true
        }
      }
    },
    stamp() {
      this.$print(this.$refs.print)
    },
    // 表格上方按钮事件 start
    handleSelectionChange(data) {
      this.selectedData = data
      console.log(this.selectedData)
    },
    handleSelectionChange2(data) {
      this.selectedData = data
      console.log(this.selectedData)
    },
    batchDelete() {
      var that = this
      var val = this.selectedData
      console.log(this.selectedData)
      if (val.length > 0) {
        this.$confirm("确认永久删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            val.forEach(function (item, index) {
              request({
                url: "/sqyl/admin/customer/info/deleteById",
                method: "POST",
                data: { id: item.id },
              })
            })
          })
          .then(() => {
            this.showlist()
            this.$message({
              type: "success",
              message: "删除成功!",
            })
          })
      } else {
        this.$confirm("请选择要删除的项。", "提示")
      }
      this.$refs.multipleTable.clearSelection()
    },

    // 身份证对补贴金额查询，获取出身年月，性别
    serchSubsidy(val) {
      console.log(val)
      let params = {
        customerIdcard: val,
      }
      params = Object.assign({}, params)
      request({
        url: "/sqyl/admin/customer/info/queryBalance",
        method: "POST",
        data: params,
      }).then((res) => {
        this.addForm.subsidyBalance = res.content.subsidyBalance
      })

      //出身年月
      var birthday = ""
      if (val != null && val != "") {
        if (val.length == 15) {
          birthday = "19" + val.substr(6, 6)
        } else if (val.length == 18) {
          birthday = val.substr(6, 8)
        }
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-")
      }
      this.addForm.customerBirthday = birthday

      // 性别
      if (val.length == 18) {
        if (val.charAt(16) % 2 == 0) {
          this.addForm.customerSex = "1"
        } else {
          this.addForm.customerSex = "0"
        }
      } else if (val.length == 15) {
        if (val.charAt(14) % 2 == 0) {
          this.addForm.customerSex = "1"
        } else {
          this.addForm.customerSex = "0"
        }
      } else {
        return ""
      }
    },
    // 身份证获取信息
    idCardchange(val) {
      console.log(val)
      // let obj = discriCard(val)
      // console.log(obj)
      //出生年月
      var birthday = ""
      if (val != null && val != "") {
        if (val.length == 15) {
          birthday = "19" + val.substr(6, 6)
        } else if (val.length == 18) {
          birthday = val.substr(6, 8)
        }
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-")
      }
      this.addForm.customerBirthday = birthday
      // 性别
      if (val.length == 18) {
        if (val.charAt(16) % 2 == 0) {
          this.addForm.customerSex = "1"
        } else {
          this.addForm.customerSex = "0"
        }
      } else if (val.length == 15) {
        if (val.charAt(14) % 2 == 0) {
          this.addForm.customerSex = "1"
        } else {
          this.addForm.customerSex = "0"
        }
      } else {
        return ""
      }
      // 年龄
      var myDate = new Date()
      var month = myDate.getMonth() + 1
      var day = myDate.getDate()
      var age = myDate.getFullYear() - val.substring(6, 10) - 1
      if (
        val.substring(10, 12) < month ||
        (val.substring(10, 12) == month && val.substring(12, 14) <= day)
      ) {
        age++
      }
      this.addForm.customerAge = age
    },

    handleClick(type, date) {
      let self = this
      this.dialogTitle = type
      this.mapshow = false
      this.resetForm("addForm1")
      this.resetForm("addForm2")
      setTimeout(async () => {
        await this.$nextTick(() => self.loadmap("container"))
      }, 30)
      // this.mapInit("container");

      switch (type) {
        case "新增":
          this.dialogVisible = true
          this.addForm.subsidyBalance = "0"
          break
        case "编辑":
          this.look(date)
          this.dialogVisible = true
          break
        case "查看":
          this.look(date)
          this.dialogVisible = true
          break
        // case "充值":
        //     this.look(date);
        //     // console.log(date)
        //     this.dialogVisible11 = true;

        //     // this.addForm.subsidyBalance1 = date.totalMoney;
        //     // console.log(this.addForm.subsidyBalance1, date.totalMoney);
        //     // console.log(date.subsidyBalance1, date.totalMoney);

        //     break;
      }
    },
    // end

    // 行点击选中
    openDetails(row, event, column, cell) {
      // console.log(row.order);
      // console.log(column);
      this.$refs.multipleTable.toggleRowSelection(row)
      this.showtext = !this.showtext
      this.row = row
      this.column = column
      // this.bgKey = this.row;
    },

    // 新增功能模态框打开事件
    opendialogVisible() {
      this.dialogVisible = true
    },
    // 打印记录
    showDialog(type, date) {
      // console.log(date);
      this.dialogVisible2 = true
      this.lookCost(date)
    },
    // 消费记录查看
    lookCost(date) {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        id: date.id,
      }
      params = Object.assign({}, params)
      request({
        url: "/sqyl/admin/pay/expenseCalendar",
        method: "POST",
        data: params,
      }).then((res) => {
        console.log(res)
        if (res.content != null) {
          this.consumption = res.content.list
          console.log(this.consumption)
        }
      })
    },
    // 预览图片
    handlePicturePreview(file) {
      this.dialogVisible1 = true
      this.dialogImageUrl = file.url
    },

    //新增模态框导航样式选择事件
    selectDialogTabs(index) {
      this.borderBotKey = index
      this.dialogBox = index
    },
    // 重置
    resert() {
      this.form = {}
      this.showlist()
    },

    // 表单刷新
    resertTable() {
      this.showlist()
      this.checkList = [
        "序号",
        "姓名",
        "是否补助人员",
        "补贴方式",
        "餐补等级",
        "余额",
        "操作",
      ]
      this.tableShow()
    },

    //每页请求数据
    handleSizeChange(val) {
      this.pageSize = val
      this.showlist()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      })
    },
    //请求第几数据
    handleCurrentChange(val) {
      this.pageNo = val
      this.showlist()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      })
    },

    //用户列表
    async showlist() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      params = Object.assign({}, params)
      await request({
        url: "/sqyl/survery/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        console.log(res)
        if (res.content != null) {
          this.tableDate = res.content.list
          this.total = res.content.count
        }
        // console.log(this.tableDate);
      })
    },

    // 查询
    async query() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form,
      }
      params = Object.assign({}, params)
      await request({
        url: "/sqyl/survery/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        // console.log(res);
        if (res.content != null) {
          this.tableDate = res.content.list
          this.total = res.content.count
        } else {
          this.tableDate = []
        }
      })
    },

    // 用户新增保存
    save() {
      this.$refs.addForm1.validate((valid1) => {
        if (valid1) {
          if (!this.addForm.provinceId) {
            this.$message.error("省级地址为必填项，请选择")
            return
          }
          if (!this.addForm.cityid) {
            this.$message.error("市级地址为必填项，请选择")
            return
          }
          if (!this.addForm.zoneid) {
            this.$message.error("区县级地址为必填项，请选择")
            return
          }
          if (!this.addForm.streetid) {
            this.$message.error("街道地址为必填项，请选择")
            return
          }
          // if (
          //     this.formData.shequid === "" ||
          //     this.formData.shequid === null ||
          //     this.formData.shequid === undefined
          // ) {
          //     this.$message.error(
          //         "社区为必填项，请选择,如无对应社区，请地址管理配置"
          //     )
          //     return
          // }
          if (!this.addForm.customerAddress) {
            this.$message.error(
              "详细信息为必填项，请在地图的边界内点击选择或手动输入"
            )
            return
          }
          if (
            this.addForm.subsidyLevel === "" ||
            this.addForm.subsidyLevel === null ||
            this.addForm.subsidyLevel === undefined
          ) {
            if (this.addForm.isSubsidy === 0) {
              this.$message.error("餐补等级不能为空")
              return
            }
          }
          if (
            this.addForm.subsidyTime === "" ||
            this.addForm.subsidyTime === null ||
            this.addForm.subsidyTime === undefined
          ) {
            if (this.addForm.isSubsidy === 0) {
              this.$message.error("补贴时长不能为空")
              return
            }
          }
          if (
            this.addForm.subsidyStartTime === "" ||
            this.addForm.subsidyStartTime === null ||
            this.addForm.subsidyStartTime === undefined
          ) {
            if (this.addForm.isSubsidy === 0) {
              this.$message.error("补贴开始时间不能为空")
              return
            }
          }
          let obj = common.organization(
            this.arrOrgList,
            this.normalInfo.orgLevel
          )
          // this.addForm.shengId = this.addForm.address1;
          // this.addForm.shiId = this.addForm.address2;
          // this.addForm.quId = this.addForm.address3;
          let params = {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            ...this.addForm,
            qujiId: obj.qujiId,
            shijiId: obj.shijiId,
            shengjiId: obj.shengjiId,
            stationId: obj.stationId,
            shequjiId: obj.shequjiId,
            orgName: obj.orgName,
            economySource: this.addForm.economySource.toString(),
          }
          params = Object.assign({}, params)
          delete params.streetId
          request({
            url: "/sqyl/admin/customer/info/insert",
            method: "POST",
            data: params,
          }).then((res) => {
            console.log(res)
            if (res.code == 200) {
              this.dialogVisible = false
              this.$message({
                message: "用户新增成功",
                type: "success",
              })
              this.showlist()
            } else {
              this.$message.error("用户新增失败")
            }
          })
        } else {
          this.borderBotKey = 1
          this.dialogBox = 1
        }
      })
    },

    // 用户查看
    async look(date) {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        id: date.id,
      }
      params = Object.assign({}, params)
      await request({
        url: "/sqyl/admin/customer/info/findById",
        method: "POST",
        data: params,
      }).then(async (res) => {
        console.log(res)
        this.addForm = {
          ...res.content,
          subsidyBalance: res.content.totalMoney,
          // this.$set(this.addForm,'',date.totalMoney)
          provinceId: String(res.content.provinceId),
          cityid: String(res.content.cityid),
          zoneid: String(res.content.zoneid),
          streetid: String(res.content.streetId),
          shequid: Number(res.content.shequid),
          orgName: String(res.content.orgName),
        }
        console.log()
        // this.formData.serviceType=res.content.serviceType.split(',');
        this.addForm.economySource = res.content.economySource.split(",")
        let self = this
        let jsonTemp = { ...this.addForm }
        if (!jsonTemp.provinceId) return
        console.log(jsonTemp.provinceId)
        let city = await self.getDistricts(jsonTemp.provinceId)
        self.cityList = city.districtList
        console.log(city, self.cityList)
        if (!jsonTemp.cityid) return
        let area = await self.getDistricts(jsonTemp.cityid)
        self.areaList = area.districtList
        if (!jsonTemp.zoneid) return
        let street = await self.getDistricts(jsonTemp.zoneid)
        self.streetList = street.districtList
        if (!jsonTemp.streetid) return
        // this.streetChange(jsonTemp.streetid, true)
        let communityList = await self.getCommityList(jsonTemp.streetid)
        self.communityList = communityList
        this.addForm.intoMoney = ""
        self.addForm.addressLng = jsonTemp.addressLng
        self.addForm.addressLat = jsonTemp.addressLat
        if (self.addForm.addressLat && self.addForm.addressLng) {
          this.potintMap()
        }
        this.showlist1()
      })
    },

    // 用户删除
    deleteId(date) {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        id: date.id,
      }
      params = Object.assign({}, params)
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/sqyl/admin/customer/info/deleteById",
          method: "POST",
          data: params,
        }).then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.showlist()
          }
        })
      })
    },

    // 刷新页面
    Resert() {
      this.reload()
    },
    // 上传图片
    changeupload() {
      this.imgdialog = true
    },
    submitUpload() {
      this.$refs.upload.submit()
    },

    helpListOut(params) {
      return request2({
        url: "/sqyl/admin/person/info/downloadPerson",
        method: "POST",
        data: params,
        responseType: "blob",
      })
    },
    // 地图显示
    location() {
      // this.mapInit("container");

      this.mapshow = !this.mapshow
      if (this.dialogTitle == "新增") {
        this.changeFirst()
      } else {
        console.log(this.addForm.addressLng)
        this.loadmap("container")
        setTimeout(() => {
          this.potintMap()
        }, 500)
      }
    },
    // 保存
    submitForm(formName) {
      this.dialogVisible = false
      this.mapshow = false
    },
    // 取消
    cancel(formName) {
      this.dialogVisible = false
      this.mapshow = false
    },
    // 关闭
    handleClose() {
      this.dialogVisible = false
      this.mapshow = false
    },
    handleClose11() {
      this.dialogVisible11 = false
    },

    // 表单重置
    resetForm(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields()
      }
    },

    chickpage(e) {
      this.formSwitch = e
    },

    handleAvatarSuccess(res) {
      this.imageUrl = res.content
      this.addForm.customerPhoto = res.content
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
      }
      return isJPG && isLt2M
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个图片，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },

    //获取地址
    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }
        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
            if (bounds) {
              try {
                self.myMap.remove(self.polygons)
              } catch (error) {
                console.log("移除地图编辑出错了")
              }
              self.polygons = []
              for (let i = 0, l = bounds.length; i < l; i++) {
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  strokeColor: "#0091ea",
                  fillColor: "#80d8ff",
                  fillOpacity: 0.4,
                  path: bounds[i],
                })
                self.polygons.push(self.polygon)
                if (!params) {
                  self.polygon.on("click", function (e) {
                    let lnglat = e.lnglat
                    self.myMap.add(self.marker)
                    self.marker.setPosition(lnglat)
                    geocoder.getAddress(lnglat, function (status, result) {
                      if (status === "complete" && result.regeocode) {
                        console.log(result.regeocode.formattedAddress)
                        var address = result.regeocode.formattedAddress
                        self.addForm.customerAddress = address
                        self.addForm.addressLng = lnglat.lng
                        self.addForm.addressLat = lnglat.lat
                      } else {
                        console.error("根据经纬度查询地址失败")
                      }
                    })
                  })
                  self.myMap.add(self.polygons)
                  self.myMap.setFitView() //地图自适应
                } else {
                  if (params.addressLng && params.addressLat) {
                    self.myMap.add(self.marker)
                    self.marker.setPosition([
                      params.addressLng,
                      params.addressLat,
                    ])
                    self.myMap.setFitView(self.marker)
                    self.myMap.setZoom(11)
                  }
                }
              }
            }
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    //获取省级
    async getProvince() {
      this.provinceLis = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.addForm.cityid = ""
      this.addForm.zoneid = ""
      this.addForm.streetid = ""
      this.addForm.shequid = ""
      this.addForm.customerAddress = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.addForm.zoneid = ""
      this.addForm.streetid = ""
      this.addForm.shequid = ""
      this.addForm.customerAddress = ""
      let area = await this.getDistrict(val)
      this.areaList = area.districtList
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.addForm.streetid = ""
      this.addForm.shequid = ""
      this.addForm.customerAddress = ""
      // val = val.replace(/.$/, "");
      let street = await this.getDistrict(val)
      this.streetList = street.districtList
    },
    async showlist1(e) {
      this.addForm.subsidyLevel = ""
      this.addForm.subsidyMoney = ""
      this.addForm.subsidyTotal = ""
      this.addForm.subsidyBalance1 = ""
      this.addForm.enableNum = ""
      this.addForm.totalMoney = ""
      this.addForm.enableAmount = ""
      this.addForm.enableallNum = ""
      this.addForm.totalMone = ""
      console.log(this.addForm.subsidyWay)
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
        shengjiId: JSON.parse(localStorage.getItem("czUserInfo")).shengjiId,
        shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
        stationId: JSON.parse(localStorage.getItem("czUserInfo")).stationId,
        shequjiId: JSON.parse(localStorage.getItem("czUserInfo")).shequjiId,
      }
      params = Object.assign({}, params, {
        ...e,
        isEnable: this.addForm.subsidyWay,
      })
      await request({
        url: "/sqyl/admin/subsidyLevel/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        this.subsidyLevelOptions = res.content.list
      })
    },
    // 餐补金额
    async subMoney(val) {
      console.log(this.addForm.subsidyWay)
      let params = {
        id: val,
      }
      params = Object.assign({}, params)
      await request({
        url: "/sqyl/admin/subsidyLevel/info/findById",
        method: "POST",
        data: params,
      }).then((res) => {
        this.addForm.enableNum = res.content.enableNum
        this.addForm.enableAmount = res.content.enableAmount
        this.addForm.enableallNum =
          res.content.enableNum * this.addForm.subsidyTime
        this.addForm.subsidyMoney = res.content.subsidyAmount
        this.addForm.subsidyTotal =
          this.addForm.subsidyMoney * this.addForm.subsidyTime
      })
      this.addForm.totalMoney =
        Number(this.addForm.subsidyTotal) + Number(this.addForm.subsidyBalance)
      console.log(this.addForm.totalMoney)
    },
    // 总金额计算 余额加补贴金额

    //加载地图
    loadmap() {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map(container, {
          resizeEnable: true,
          zoom: 18,
        })
        resolve()
      })
    },
  },

  //     computed: {
  //   getYmd() {
  //     // 计算属性使用闭包传参
  //     return  (n) =>{
  //       let val = this.addForm.subsidyStartTime;
  //       if(!val) return;
  //       if(n === this.addForm.subsidyTime){
  //         this.addForm.subsidyEndTime = this.computeYmd(val, this.addForm.subsidyTime);
  //       }
  //       // if(n === 36){
  //       //   this.contractInfo.endDate = this.computeYmd(val, 36);
  //       // }
  //     }
  //   }
  // },
}
</script>
<style lang='less' scoped>
// 新增功能模态框导航样式
.addFrom {
  .el-dialog__header {
    text-align: center;
  }

  .el-form-item__label {
    border: 1px solid #000;
  }

  .el-form-item {
    // dialog输入框居右对齐
    margin: 0;
    // 输入框
    input {
      height: 30px;
    }
  }

  // 新增功能模态框tabs
  .addDialogTabs {
    width: 100%;
    display: flex;
    font-size: 14px;
    justify-content: space-between;

    .borderBot {
      border-bottom: 2px solid #169bd5;
    }

    /deep/ .el-dialog__body {
      padding-top: 0px !important;
    }

    /deep/ .el-dialog__footer {
      text-align: center;
    }
  }

  .addDialogTabs > div {
    cursor: pointer;
    font-size: 14px;
    width: 50%;
    height: 50px;
    display: flex;
    margin-bottom: 10px;
    justify-content: center;
    align-items: center;
    border-bottom: 2px solid #e4e4e4;
  }

  .dialogBody {
    display: flex;
    // width: 100%;
    .dialogBodyright {
      width: 100%;
    }
  }

  /deep/ .el-dialog {
    /deep/ .el-dialog__header {
      border-bottom: 1px solid #e6e6e6;
    }

    /deep/ .el-dialog__body {
      padding-top: 0px !important;
    }
  }

  /deep/ .imgdialog {
    /deep/ .el-dialog__body {
      padding-top: 10px !important;
    }
  }

  // 模态框居住情况
  .dialogLiveRadio {
    display: flex;
    align-items: center;
  }
}

// 弹框底部
/deep/ .el-dialog .el-dialog__footer {
  background-color: #f5f5f5;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/deep/ .el-upload--picture-card {
  width: 178px;
  height: 178px;
}

// --------------------------------------------
.rkld {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}

.rkldLeft {
  width: 234px;
  height: 100%;
  background: #37404f;
}

.rkldLeftLogo {
  background-color: rgb(55, 64, 79);
  height: 68px;
  width: 100%;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.rkldLeftLogoImage {
  width: 39px;
  margin-left: 20px;
  margin-right: 10px;
}

.rkldRight {
  flex: 1;
  height: 100%;
  width: calc(100% - 266px);
  background-color: #ffffff;
}

.rkldRightHead {
  border-bottom: 1px solid #f5f5f5;
  width: 100%;
  background-color: #ececec;
  height: 69px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.mlIcon {
  height: 35px;
  width: 35px;
  font-size: 14px;
  margin-left: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 3px;
}

.mlIcon:hover {
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar {
  display: none !important;
}

.rkldRightHeadRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 15px;
}

.demo-form-inline {
  padding: 0 5%;
}

.btnform {
  text-align: center;
}

.bodymsg {
  width: 140px;
  height: 40px;
  background-color: #ffb404;
  color: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 2px;
  margin-top: 20px;
  cursor: pointer;
}

.switchpage {
  display: inline-block;
  margin-bottom: 10px;
}

.activesiwtch {
  background-color: #d6d7d8;
}

.rkldRightHeadRightLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
}

.rkldRightHeadRightLeft img {
  margin-right: 5px;
}

.rkldRightContent {
  height: calc(100% - 70px);
  overflow-y: auto;
  margin: 20px;
}

.searchTj {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f1f2f6;
  box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
  overflow: hidden;
  border-radius: 4px;
  margin: 5px;
}

.searchTjHead {
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: rgb(0, 0, 0);
  border-color: rgb(217, 217, 217);
  padding: 6px 15px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.searchTjContent {
  padding: 15px 20px 0px 5px;
  border: 1px solid rgb(217, 217, 217);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.searchTjContentDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 40px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.searchTjContentDivSpan {
  min-width: 58px;
  margin-right: 20px;
  font-size: 14px;
}

.searchTjContentDivInput {
  width: 20%;
  min-width: 196px;
}

/deep/ .arrowDown {
  width: 28px;
  height: 28px;
  background: #edf2f0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: -14px;
  transform: translate(-50%, 0px) 2s;
  border-radius: 50%;
  z-index: 2;
  cursor: pointer;
  // transition: 2s;
}

/deep/ .el-tabs__content {
  padding-bottom: 20px;
}

.searchButtonDiv {
  height: 54px;
  display: flex;
  margin-top: 14px;
  align-items: center;
  justify-content: space-between;
}

.searchButtonDivLeft {
  display: flex;
}

/deep/ .el-button {
  border-radius: 4px;
  padding: 0px 8px !important;
  border: none;
  height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
  border-left-color: rgba(255, 255, 255, 0.5);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
  margin-top: 10px;
}

/deep/ .el-submenu__title i {
  color: #fff;
}

.el-submenu /deep/ .el-menu-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/ .el-submenu__title {
  border-bottom: 1px solid #2c3342;
  background: rgb(55, 64, 79) !important;
}

/deep/ .el-menu-item {
  border-bottom: 1px solid #2c3342;
  background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
  border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
  .el-tabs--card
  > .el-tabs__header
  /deep/
  .el-tabs__item.is-active.is-closable {
  color: #0e2d5f;
}

/deep/ .el-menu .is-active {
  color: rgb(255, 255, 255) !important;
  background-color: #437ae1 !important;
}

/deep/ .el-submenu {
  width: 234px !important;
}

/deep/ .el-menu-item:hover {
  color: rgb(255, 255, 255) !important;
  background-color: #437ae1 !important;
}

/deep/ .tabBtn {
  margin: 0px;
}

.rkld .el-menu-vertical-demo:not {
  background: rgb(55, 64, 79) !important;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
  background-color: #fafad2 !important;
  color: #000;
}

/deep/ .el-table tbody tr:hover > td {
  background-color: #fafad2 !important;
}

.mapleft {
  margin-left: 10px;
  width: 200px;
  height: 400px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 5px;

  p {
    line-height: 42px;
    text-align: center;
  }
}

/deep/ .map_left {
  width: 100%;
  height: 400px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 5px;

  p {
    line-height: 42px;
    text-align: center;
  }
}

#myPageTop {
  position: absolute;
  top: -50px;
  right: 10px;
  background: #fff none repeat scroll 0 0;
  margin: 10px auto;
  padding: 6px;
  font-size: 14px;
}

#myPageTop input {
  width: 170px;
}

#myPageTop .column2 {
  padding-left: 25px;
}
.labelImportBtn {
  background: #23c6c8;
  border-radius: 3px;
  cursor: pointer;
  // margin: 0 10px;
  font-size: 12px;
  padding: 4px 5px;
  color: #fff;
  line-height: 28px;
  display: inline-block;
}
.shuiBtn{margin-left: 15px;padding: 10px 8px !important;height: 36px !important;}
</style>
